module.exports = __webpack_public_path__ + "assets/5708b40d90da7274e220df6bc7ff6b27.svg";